/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 * See the LICENSE file for the full text.
 */

import React from 'react';

/**
 * The shape of the form, while the form is on its way.
 *
 * Shown instead of the word "Loading…". By the time this renders the shell is
 * already up — rail, topbar, step pills — so what is missing is the form
 * itself, and the honest thing to show is its outline. A word in the corner
 * reads as a page that has stalled; blocks in roughly the right places read as
 * one that is arriving, and the layout does not jump when it does.
 *
 * `aria-busy` with a plain-text label is what a screen reader gets: the bars
 * are decoration and say nothing useful, so they are hidden from it entirely.
 */
export default function FormSkeleton({ label = 'Loading the event form' }) {
  return (
    <div className="orgf-skel" role="status" aria-busy="true" aria-live="polite">
      <span className="sr-only-org">{label}…</span>

      <div className="orgf-skelcard" aria-hidden="true">
        <div className="orgf-skelline lab" />
        <div className="orgf-skelline field" />
        <div className="orgf-skelrow">
          <div className="orgf-skelline field" />
          <div className="orgf-skelline field" />
        </div>
      </div>

      <div className="orgf-skelcard" aria-hidden="true">
        <div className="orgf-skelline lab" />
        <div className="orgf-skelline field" />
        <div className="orgf-skelrow">
          <div className="orgf-skelline field" />
          <div className="orgf-skelline field" />
          <div className="orgf-skelline field" />
        </div>
        <div className="orgf-skelline half" />
      </div>
    </div>
  );
}
